import React from "react";

import PharmacyDesktopHeader from "@/components/nav/PharmacyDesktopHeader.jsx";
import LayoutShell from "@/components/ui/LayoutShell.jsx";
import AppearanceCommon from "@/features/settings/AppearanceCommon.jsx";
import { useAuth } from "@/contexts/AuthContext.jsx";
import { updatePharmacyMemberThemePreference } from "@/services/pharmacyMemberAccountService.js";

export default function PharmacyAppearance() {
  const auth = useAuth() || {};
  const userId = String(auth?.user?.id || "").trim();

  return (
    <LayoutShell hideTabs flushTop freeScroll manageOwnTabLayout railClassName="w-full">
      <PharmacyDesktopHeader section="settings" />
      <AppearanceCommon
        role="pharmacy"
        backTo="/pharmacy/dashboard"
        onPersistTheme={
          userId
            ? async (nextTheme) => {
                await updatePharmacyMemberThemePreference({
                  userId,
                  themePreference: nextTheme,
                });
              }
            : undefined
        }
      />
    </LayoutShell>
  );
}
